module.exports = __webpack_public_path__ + "img/apple_icon.2113c802.svg";